module.exports = __webpack_public_path__ + "static/media/gino.fe7d16e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/gino.png
// module id = 1424
// module chunks = 0